UNION_TYPE_DEFINITION